import { render } from "./AktiveAbonnementer.vue?vue&type=template&id=94ce44d8"
import script from "./AktiveAbonnementer.vue?vue&type=script&lang=js"
export * from "./AktiveAbonnementer.vue?vue&type=script&lang=js"

import "./AktiveAbonnementer.vue?vue&type=style&index=0&id=94ce44d8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__